import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

import { PATHS } from "../../../app/router/paths";
import { useAuth } from "../model/AuthContext";

export const ForbiddenPage = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate(PATHS.AUTH.LOGIN, { replace: true });
  };

  return (
    <Result
      status="403"
      title="403"
      subTitle="この画面を表示する権限がありません。"
      extra={<Button onClick={handleLogout}>ログアウト</Button>}
    />
  );
};
